import { render, staticRenderFns } from "./smtPackageOutTb.vue?vue&type=template&id=29aa2353&scoped=true"
import script from "./smtPackageOutTb.vue?vue&type=script&lang=js"
export * from "./smtPackageOutTb.vue?vue&type=script&lang=js"
import style0 from "./smtPackageOutTb.vue?vue&type=style&index=0&id=29aa2353&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29aa2353",
  null
  
)

export default component.exports